import { Events } from '|>/shared/events'
import { Intent } from '|>/shared/types/intent'
import { on, register } from '|>/shared/vjs'
import { BaseButton } from '../base'

import './play-next.css'

/**
 * Play next button component
 */
@register
export class PlayNext extends BaseButton {
  @on(Events.Controls.ShowPlayNextControl)
  changeVisibility(visible: Events.Controls.ShowPlayNextControl) {
    if (visible) this.show()
    else this.hide()
  }

  override handleClick(event: MouseEvent) {
    event.stopPropagation()
    this.player_.trigger(Events.User.Intent, Intent.PlayNext)
    this.player_.trigger(Events.Player.PlayNext)
  }
}

PlayNext.options = {
  className: 'vjs-x-next-button',
}
